import { BaseFullScreenModalRender } from "../../../../base/modal/BaseFullScreenModalRender";
import { IConnectRender } from "../../../../definitions/IConnectRender";
import { serviceProvider } from "../../../../../comun/provider/ServiceProvider";
import { MonitoreoBrocaSplitMapRender } from "../map/MonitoreoBrocaSplitMapRender";

/** Modal a pantalla completa con la vista dividida de Monitoreo Broca (dos
 *  mapas comparando semanas distintas). */
export class MonitoreoBrocaSplitViewModalRender extends BaseFullScreenModalRender {
  protected readonly elementId = "monitoreoBrocaSplitViewModal";

  protected get title(): string {
    return "Monitoreo Broca - Vista dividida";
  }

  protected get subtitle(): string | undefined {
    return serviceProvider.getFincaSelectedService().getRequired().nombreFinca;
  }

  protected getContent(): IConnectRender {
    return new MonitoreoBrocaSplitMapRender();
  }
}
